module.exports = __webpack_public_path__ + "img/banner_bg_001.ddf89c6.webp";